import { faSignOutAlt } from '@fortawesome/pro-light-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import styled from 'styled-components';
import { logoff } from '../../../../services/repository/userPoliciesRepository';
import IconButton from '../../../atoms/IconButton';
import AuthorizedModules from './AuthorizedModules';

const IconMenuWrapper = styled.div`
  height: 100%;
  width: 64px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  border-right: 2px solid rgba(217, 217, 217, 0.38);

  > :first-child {
    margin-top: 48px;
  }
  > :last-child {
    margin-bottom: 80px;
  }
`;

const Logo = styled.img`
  width: 40px;
`;

function IconMenu() {
  return (
    <IconMenuWrapper>
      <Logo
        src={process.env.REACT_APP_LOGO_URL}
        alt="app logo"
      />
      <AuthorizedModules />
      <IconButton
        onClick={logoff}
        icon={
          <FontAwesomeIcon
            icon={faSignOutAlt}
            size="lg"
          />
        }
      >
        <b>Sair</b>
      </IconButton>
    </IconMenuWrapper>
  );
}

IconMenu.propTypes = {};

export default IconMenu;
